import { Pipe, PipeTransform } from '@angular/core';

/**
 * This is intended to be used within a flow tasks but it can be used in other places too.
 * Translate a property of an object that has "it" and "en" keys based on the current language.
 * Example:
 * {
 *    "title": {
 *      "it": "Titolo",
 *      "en": "Title"
 *    }
 * }
 *
 * Usage:
 *    title | translateProp: lang
 */

@Pipe({ name: 'i18n' })
export class i18n implements PipeTransform {
  transform(obj: any, lang?: 'it' | 'en' | 'pt'): string {
    // Native JavaScript replacement for lodash.get
    return obj?.[lang ?? 'en'];
  }
}
